import React from "react";
import "../../../css/Turismo/lugares-ciudad.css";

const destacados = [
  {
    titulo: "Oficina de Turismo",
    href: "/turismo/oficina-de-turismo",
    img: require("../../img/Oficina-de-Turismo.jpg"),
  },
  {
    titulo: "Terminal de Ómnibus",
    href: "/turismo/terminal-de-omnibus",
    img: require("../../img/Terminal01.jpeg"),
  },
  {
    titulo: "Estación de Trenes",
    href: "/turismo/estacion-de-trenes",
    img: require("../../img/Estacion-de-Trenes.jpeg"),
  },
  {
    titulo: "Museo Nacional de Malvinas",
    href: "/turismo/museo-nacional-de-malvinas",
    img: require("../../img/Museo-1.jpg"),
  },
];

const TarjetasDestacados = () => (
  <div className="row mt-3 contenedor-tarjetas">
    {destacados.map((d, i) => (
      <div className="col-12 col-md-6 col-lg-3" key={i}>
        <a href={d.href} style={{ textDecoration: "none", color: "inherit" }}>
          <div className="card-referencias">
            <div className="img-referencias">
              <img src={d.img} alt={d.titulo} />
              <div className="overlay"></div>
              <div className="text-container">
                <h2 style={{ fontSize: 20 }}>{d.titulo}</h2>
              </div>
            </div>
          </div>
        </a>
      </div>
    ))}
  </div>
);

export default TarjetasDestacados;
